import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "polyfill";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "store";
import App from "components/App";
import { icons } from "assets/icons";

React.icons = icons;

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
